"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = times;
var _identity = _interopRequireDefault(require("./identity"));
var _range = _interopRequireDefault(require("./range"));
function times(invokeAmount) {
  var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity.default;
  if (typeof invokeAmount !== 'number' || typeof iteratee !== 'function') {
    return [];
  }
  if (invokeAmount < 0) {
    return [];
  }
  return (0, _range.default)(0, invokeAmount).map(iteratee);
}
//# sourceMappingURL=times.js.map